import { Country } from '../../lib/types/models/country/country'
import { CountryInput } from '../../lib/types/models/country/country-input'

export const mapCountryToInput = (country: Country): CountryInput => {
  return {
    code: country.code,
    name: country.name,
    vat: country.vat,
    timezone: country.timezone,
    position: country.position,
    displayToStaff: country.displayToStaff,
    requiredDocuments: country.requiredDocuments
  }
}
